import { subDays, isSameDay, format, startOfDay } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { groupBy, map } from 'lodash';
import constants from './constants';
import appConstants from '../../../../../appConstants';

const getFieldError = (field, value) => {
  switch (field) {
    case 'selectedDriverId':
      return value ? null : constants.VALIDATION_MESSAGE.REQUIRED;
    case 'selectedDateRange':
      return getDateRangeError(value);
    case 'selectedTimePeriod':
      return value === appConstants.INVALID_TIME_RANGE
        ? constants.VALIDATION_MESSAGE.INVALID_TIME_PERIOD_INPUT
        : '';
    default:
      return null;
  }
};

const getDateRangeError = (date) => {
  if (!date[0].startDate || !date[0].endDate) {
    return constants.VALIDATION_MESSAGE.REQUIRED;
  }
  return null;
};

const getDefaultErrorInfo = () => ({
  selectedDriverId: '',
  selectedDateRange: '',
  selectedTimePeriod: ''
});

const getDefaultDateRange = (startDate, endDate) => {
  return [
    {
      startDate: startDate ? new Date(startDate) : subDays(new Date(), constants.LAST_ONE_WEEK + 1),
      endDate: endDate ? new Date(endDate) : new Date(),
      key: 'selection'
    }
  ];
};

const getQueryString = ({ selectedDateRange, selectedTimePeriod, driverNumber }) => {
  const { startDate, endDate } = selectedDateRange[0];
  let requestObject = {
    driverNumber,
    startDate: format(startDate, appConstants.APP_DATE_FORMAT),
    endDate: format(endDate, appConstants.APP_DATE_FORMAT),
    sendCurrentDateMessage: isSameDay(endDate, new Date())
  };
  if (selectedTimePeriod) {
    const startTime = selectedTimePeriod.trim().split('-')[0].trim() || '';
    const endTime = selectedTimePeriod.trim().split('-')[1].trim() || '';
    requestObject = {
      ...requestObject,
      startTime,
      endTime
    };
  }
  const defaultQueryString = `driverNumber=${requestObject.driverNumber}&startDate=${requestObject.startDate}&endDate=${requestObject.endDate}&sendCurrentDateMessage=${requestObject.sendCurrentDateMessage}`;
  return requestObject.startTime && requestObject.endTime
    ? `${defaultQueryString}&startTime=${requestObject.startTime}&endTime=${requestObject.endTime}`
    : defaultQueryString;
};

const isValidInputs = (errorInfo) => {
  return !Object.values(errorInfo).filter((value) => value).length;
};

const isYesterday = (zonedMessageDate, terminalOffset) => {
  const currentDate = utcToZonedTime(new Date(), terminalOffset);
  const yesterdayDate = subDays(startOfDay(currentDate), 1);
  return isSameDay(zonedMessageDate, yesterdayDate);
};

const getFormattedDate = (messageDateTs, terminalOffset) => {
  const zonedMessageDate = utcToZonedTime(messageDateTs, terminalOffset);
  const yesterday = isYesterday(zonedMessageDate, terminalOffset);
  if (yesterday) {
    return 'Yesterday';
  }
  return format(zonedMessageDate, constants.GROUPED_DATE_MESSAGE_FORMAT);
};

const getGroupedMessageTerminalCodes = (messages) => {
  return [
    ...new Set(messages.filter((msg) => msg.terminalCode).map((msg) => msg.terminalCode))
  ].join(', ');
};

const getMessageHistoryGroupedByDate = (messages, terminalOffset) => {
  const groupedMessages = groupBy(messages, (message) =>
    getFormattedDate(message.messageDateTs, terminalOffset)
  );
  return map(groupedMessages, (messages, date) => ({
    date,
    messages,
    terminalCodes: getGroupedMessageTerminalCodes(messages),
  }));
};

export {
  getFieldError,
  getDefaultErrorInfo,
  getDefaultDateRange,
  getQueryString,
  isValidInputs,
  getMessageHistoryGroupedByDate,
  getGroupedMessageTerminalCodes
};
